<template>
  <div class="container-fuluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>{{pageTitle}}</h5>
      </div>
      <div class="col-4">
        <button id="createUserBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create" v-if="isSuper">新しく登録する</button>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-9">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:50px">#</th>
              <th scope="col">ID</th>
              <th scope="col">名称</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(hospital, index) in hospitals" v-bind:key="hospital.id">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ hospital.hospitalCode }}</td>
              <td>{{ hospital.hospitalName }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="modify(hospital.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function () {
    return {
      hospitals: [],
      message: '',
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !==0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    },
    isSuper: function () {
      return Number(this.$store.state.user.privilege) === authority.isSuper
    },
    pageTitle: function (){
      return this.serviceName === 'SmartPhone' ? '事業所一覧' : '病院一覧'
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/hospital/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/hospital/modify/'+id))
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          if(isInit){
            this.currentIndex = 0
          }
          var offset = this.currentIndex * this.limit
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var url = this.isSuper ? "/api/hospital/management/list/" + offset : "/api/hospital/list/"
          axios
            .post(url, {
              hospitalId : hospitalId
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.hospitals = response.data.data.hospitals;
              this.gridCount = this.hospitals.length
            })
            .catch(err => {
              this.message = err.message
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch(err => {
        this.message = err.message
      })
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createUserBtn {
  float:right;
}
.btn-sm{
  margin-left: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>